import { Region } from 'constants/shop';
import { CollectionHandles } from './types';

/**
 * Collections the frontend only fetches products from — sliders, upsells, pop-ups, campaigns.
 * They are deliberately kept out of COLLECTION_HANDLES: nothing here may be used to build a
 * /collections/ link, key FILTER_CONFIG or resolve a handle coming from the URL.
 */
export const PRODUCT_FEED_HANDLES = {
  dogsHomeSpecial: {
    [Region.DE]: 'home-page-special-hunde',
    [Region.NL]: 'home-page-special-honden',
  },
  catsHomeSpecial: {
    [Region.DE]: 'home-page-special-katzen',
    [Region.NL]: 'home-page-special-katten',
  },
  dogsSubscriptionRecommendation: {
    [Region.DE]: 'abodetail_subscriptionrecommendation_dog',
    [Region.NL]: 'abodetail_subscriptionrecommendation_dog',
  },
  catsSubscriptionRecommendation: {
    [Region.DE]: 'abodetail_subscriptionrecommendation_cat',
    [Region.NL]: 'abodetail_subscriptionrecommendation_cat',
  },
  dogsSubscriptionUpsell: {
    [Region.DE]: 'subscription_upsell_dog',
    [Region.NL]: 'subscription_upsell_dog',
  },
  catsSubscriptionUpsell: {
    [Region.DE]: 'subscription_upsell_cat',
    [Region.NL]: 'subscription_upsell_cat',
  },
  dogsSpeedDelivery: {
    [Region.DE]: 'subscription-speed-delivery-dog',
    [Region.NL]: 'subscription-speed-delivery-dog',
  },
  catsSpeedDelivery: {
    [Region.DE]: 'subscription-speed-delivery-cat',
    [Region.NL]: 'subscription-speed-delivery-cat',
  },
  catsTrialPacks: {
    [Region.DE]: 'probierpakete-fur-katzen',
    [Region.NL]: 'proefpakketten-voor-katten',
  },
  // Campaign collections: compared against the URL, but never linked to from the app.
  dogsBlackWeekend: {
    [Region.DE]: 'black-weekend-fur-hunde',
    [Region.NL]: 'black-weekend-voor-honden',
  },
  catsBlackWeekend: {
    [Region.DE]: 'black-weekend-fur-katzen',
    [Region.NL]: 'black-weekend-voor-katten',
  },
} as const satisfies CollectionHandles;

export type ProductFeedKey = keyof typeof PRODUCT_FEED_HANDLES;
